import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { User } from "@dm-online/shared";

interface AuthState {
  user: User | null;
  token: string | null;
  // 明示的にログアウトした直後か（ゲストの自動サインインを止めてログイン画面へ行くため。保存しない）
  loggedOut: boolean;
  setAuth: (user: User, token: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      loggedOut: false,
      setAuth: (user, token) => set({ user, token, loggedOut: false }),
      clearAuth: () => set({ user: null, token: null, loggedOut: true }),
    }),
    {
      name: "dm-auth",
      partialize: (state) => ({ user: state.user, token: state.token }),
    }
  )
);

// ゲストとしてサインインする。成功したら true
export async function startGuestSession(): Promise<boolean> {
  try {
    const res = await fetch(`${import.meta.env.VITE_API_BASE ?? ""}/api/auth/guest`, {
      method: "POST",
    });
    if (!res.ok) return false;
    const { user, token } = (await res.json()) as { user: User; token: string };
    useAuthStore.getState().setAuth(user, token);
    return true;
  } catch {
    return false;
  }
}
